module.exports = __webpack_public_path__ + "assets/img/img240.1ed6e27d.png";